import { Component, h } from 'preact';
import cx from 'classnames';

import { Inquiry } from '../../../../../types/inquiries';
import { toDecimal } from '../../../../../core/decimal';

interface InquiryCollectionAmountDisplayProps {
  amount: number;
  inquiry: Inquiry;
  onEditClick: (inquiry: Inquiry) => void;
}

export class InquiryCommissionAmountDisplay extends Component<InquiryCollectionAmountDisplayProps> {
  render(props: InquiryCollectionAmountDisplayProps) {
    let formattedTotal: string = '(no data)';
    let buttonMarkup: any = "";

    if (props.amount) {
      formattedTotal = `PHP ${toDecimal(props.amount)}`;
    }
    if (!props.inquiry.collected) {
      buttonMarkup = <button className="btn btn-link hi-inqcolamtdisp__edit-button" onClick={ () => this.props.onEditClick(props.inquiry) }><i className="far fa-edit" /></button>
    }

    return (
      <div className="hi-inqcolamtdisp">
        <span className="hi-inqcolamtdisp__tbc-label">To be collected:</span>
        <div className="d-flex">
          <span className={ cx('hi-inqcolamtdisp__amount', { 'hi-inqcolamtdisp__amount--collected': props.inquiry.collected }) }>
            { formattedTotal }
          </span>
          { buttonMarkup }
        </div>
      </div>
    );
  }
}
